module.exports = __webpack_public_path__ + "static/media/settings-green.3ccbebd1.svg";